module.exports = __webpack_public_path__ + "img/urdu.91df58c4.png";